<template>
  <div>
    <app-tab-locked v-if="isLocked" name="Pojedynki"></app-tab-locked>

    <div class="wrapper" v-else>
      <div class="settings">
        <h2>Pojedynki</h2>
        <div class="select">
          <select v-model.number="selectedID">
            <option v-for="opt in finals" :value="opt.id" :key="opt.id">
              {{ getName(opt.id) }}
            </option>
          </select>
        </div>
      </div>
      <div class="centered">
        <app-panzoom-wrapper :initialZoom="0.7">
          <app-final-bracket :id="selectedID"></app-final-bracket>
        </app-panzoom-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
import FinalBracket from '@/components/FinalBracket.vue'
import PanzoomWrapper from '@/components/PanzoomWrapper.vue'
import TabLocked from '@/components/TabLocked.vue'

export default {
  name: 'finals',

  data() {
    return {
      selectedID: 0,
    }
  },

  watch: {
    selectedID(id) {
      console.log('selectedID -> id', id)
      this.$emit('panzoom-reset')
    },
    finals(finals) {
      this.selectedID = finals[0].id ?? 0
    },
  },

  computed: {
    cache() {
      return this.$store.state.cache
    },
    finalsSettings() {
      return this.cache.settings.finals
    },
    finals() {
      return this.cache.finals
    },
    selected() {
      return this.finals.find((el) => el.id == this.selectedID)
    },
    isLocked() {
      return this.$store.state.cache.live.lockedTabs.indexOf(3) > -1
    },
  },

  created() {
    this.selectedID = this.finals[0]?.id ?? 0
  },

  methods: {
    getName(id) {
      const current = this.finalsSettings.find((el) => el.id == id)
      const category = this.cache.settings.categories.find((el) => el.id == current.category)
      const type = current.type == 0 ? 'Indywidualnie' : current.type == 1 ? 'Zespół' : 'Mikst'

      return type + ' - ' + (current.name || category.name)
    },
  },

  components: {
    appFinalBracket: FinalBracket,
    appPanzoomWrapper: PanzoomWrapper,
    appTabLocked: TabLocked,
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
@import '@/scss/_mixins.scss';

.settings {
  position: absolute;
  background-color: #fff;
  top: 24px;
  left: 24px;
  border-radius: 16px;
  box-shadow: 0px 0px 0px 2px #edeff6;
  padding: 16px;
  z-index: 100;

  h2 {
    margin-top: 0;
  }

  @media #{$media-sm} {
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.8rem;
    padding: 8px;
    border-radius: 8px;

    h2 {
      font-size: 1.2em;
    }
  }
}

.wrapper {
  position: relative;
  width: calc(100vw + 68px);
  height: calc(100vh + 68px);
  transform: translate(-34px, -34px);

  @media #{$media-sm} {
    width: calc(100vw - 42px);
    height: calc(100vh - 48px);

    transform: translate(-4px, -4px);
    transform: none;
  }
}

.centered {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
